import {
  GET_PBSS_INTERNATIONAL,
  GET_PBSS_INTERNATIONAL_FAILED,
  UPDATE_PBSS_INTERNATIONAL,
} from '../../Constant/ActionTypes';

const initialState = {
  allPbssInternational: false,
  allPbssInternationalFailed: false,
  isUpdatePbssInternational: false,
};
const PbssInternationalReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PBSS_INTERNATIONAL_FAILED:
      return {...state, allPbssInternationalFailed: action.payload !== false};
    case GET_PBSS_INTERNATIONAL:
      return {
        ...state,
        allPbssInternational: action.payload,
        allPbssInternationalFailed: false,
      };
    case UPDATE_PBSS_INTERNATIONAL:
      return {
        ...state,
        isUpdatePbssInternational: true,
        allPbssInternational: false,
      };
    default:
      return state;
  }
};

export default PbssInternationalReducer;
